export enum PlayingState {
  playing = "playing",
  paused = "paused",
}

export enum BufferingState {
  buffering = "buffering",
  ready = "ready",
}

export enum WaitingState {
  waiting = "waiting",
  ready = "ready",
}

export enum PlayerStateWithBuffering {
  playing = "playing",
  paused = "paused",
  buffering = "buffering",
}
